import type { Locale } from './resources';

export const LOCALE_STORAGE_KEY = 'what-the-ignore:locale';
export const THEME_STORAGE_KEY = 'what-the-ignore:theme';

export type ThemePreference = 'dark' | 'light';

export function readStoredLocale(storage: Storage | null = browserStorage()): Locale | null {
  try {
    const value = storage?.getItem(LOCALE_STORAGE_KEY);
    return value === 'en' || value === 'zh-CN' ? value : null;
  } catch {
    return null;
  }
}

export function storeLocale(locale: Locale, storage: Storage | null = browserStorage()): boolean {
  if (storage === null) {
    return false;
  }
  try {
    storage.setItem(LOCALE_STORAGE_KEY, locale);
    return true;
  } catch {
    return false;
  }
}

export function readStoredThemePreference(
  storage: Storage | null = browserStorage(),
): ThemePreference | null {
  try {
    const value = storage?.getItem(THEME_STORAGE_KEY);
    return value === 'dark' || value === 'light' ? value : null;
  } catch {
    return null;
  }
}

export function storeThemePreference(
  theme: ThemePreference,
  storage: Storage | null = browserStorage(),
): boolean {
  if (storage === null) {
    return false;
  }
  try {
    storage.setItem(THEME_STORAGE_KEY, theme);
    return true;
  } catch {
    return false;
  }
}

export function resolveLocale(stored: Locale | null, languages: readonly string[]): Locale {
  if (stored !== null) {
    return stored;
  }
  return languages.some((language) => language.toLowerCase().startsWith('zh')) ? 'zh-CN' : 'en';
}

export function detectLocale(): Locale {
  const languages =
    typeof navigator === 'undefined'
      ? []
      : navigator.languages.length > 0
        ? navigator.languages
        : [navigator.language];
  return resolveLocale(readStoredLocale(), languages);
}

function browserStorage(): Storage | null {
  if (typeof window === 'undefined') {
    return null;
  }
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}
